import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const privilege = {
  namespaced: true,

  state: () => ({
    loading: false,
    PrivilegeRegistrationSuccess: false,
    PrivilegeRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _PrivilegeRegistrationSuccess: state =>
      state.PrivilegeRegistrationSuccess,
    _PrivilegeRegistrationFailure: state => state.PrivilegeRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    Privilege_REGISTRATION_SUCCESS (state, value) {
      state.PrivilegeRegistrationSuccess = value
    },
    Privilege_REGISTRATION_FAILURE (state, value) {
      state.PrivilegeRegistrationFailure = value
    }
  },

  actions: {
    CreatePrivilege ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/Priviledge/CreatePriviledge', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // token expired(unauthorized user)
            if (response?.responseCode === 4 || response?.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            }
            commit('LOADING', false)
            commit('Privilege_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('Privilege_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    UpdatePrivilege ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/Priviledge/UpdatePriviledge', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // token expired(unauthorized user)
            if (response?.responseCode === 4 || response?.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            }
            commit('LOADING', false)
            commit('Privilege_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('Privilege_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    GetAllPriviledge ({ rootState, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get('/Priviledge/GetAllPriviledge', { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetByIdPrivilege ({ commit, rootState, dispatch }, previledgeId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/Priviledge/GetPriviledge?previledgeId=${previledgeId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetInhouseAllPrivilegesByOperation ({ commit, rootState, dispatch }, OperationId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/Priviledge/GetInhouseAllPrivilegesByOperation?OperationId=${OperationId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default privilege
